import { Spin } from "antd";
import PageHeader from "components/PageHeader";
import { CAMPAIGN_TYPE } from "features/Campaign/constants";
import { t } from "i18next";
import CampaignForm from "../Form";
import CashDiscountForm from "../Form/CashDiscountForm";
import useCloneForm from "./useCloneCampaign";

const CloneCampaign = () => {
  const {
    form,
    id,
    handleUpdateClick,
    data,
    isApplyWithPromotion,
    handleValuesChange,
    handleCheckIsApplyWithPromo,
    promotionCampaignTiers,
    visibleConfirmModal,
    handleOpenConfirmModal,
    handleCancelConfirmModal,
    dataConfirmModal,
    loadingDataUpdate,
    initValues,
    loadingAll,
    indexErrorCombo,
    GET_QUERY,
    handleProductDataSourceChange,
  } = useCloneForm();

  const pageTitle = () => {
    switch (GET_QUERY.campaignType) {
      case CAMPAIGN_TYPE.COMBO_PROMO:
        return "Clone khuyến mãi theo combo";
      case CAMPAIGN_TYPE.TOP_SALES:
        return "Clone khuyến mãi đua top";
      case CAMPAIGN_TYPE.PRODUCT_PROMO:
        return "Clone khuyến mãi trên 1 sản phẩm";
      case CAMPAIGN_TYPE.CASH_DISCOUNT:
      case "CASH_DISCOUNT":
        return "Clone chiết khấu tiền mặt";
      case CAMPAIGN_TYPE.ORDER_PROMO:
        return "Clone khuyến mãi trên 1 đơn hàng";
      case CAMPAIGN_TYPE.LUCKY_WHEEL:
        return "Clone vòng quay may mắn";
      default:
        return "#";
    }
  };

  return (
    <Spin spinning={loadingAll || loadingDataUpdate}>
      <PageHeader
        pageTitle={pageTitle()}
        routes={[
          {
            path: "/campaign",
            name: t("campaign.form.list"),
          },
          {
            path: `/campaign/detail/${id}`,
            name: data?.name,
          },
        ]}
      />
      {GET_QUERY.campaignType === CAMPAIGN_TYPE.CASH_DISCOUNT || GET_QUERY.campaignType === "CASH_DISCOUNT" ? (
        <CashDiscountForm
          form={form}
          isUpdate={true}
          isApplyWithPromotion={isApplyWithPromotion}
          handleValuesChange={handleValuesChange}
          handleCheckIsApplyWithPromo={handleCheckIsApplyWithPromo}
          handleActionCampaign={handleUpdateClick}
          visibleConfirmModal={visibleConfirmModal}
          handleOpenConfirmModal={handleOpenConfirmModal}
          handleCancelConfirmModal={handleCancelConfirmModal}
          dataConfirmModal={dataConfirmModal}
          loadingUpdate={loadingAll}
          createLoading={loadingAll}
          initialValues={initValues}
        />
      ) : (
        <CampaignForm
          form={form}
          isUpdate={true}
          dataCampaign={data}
          isApplyWithPromotion={isApplyWithPromotion}
          handleValuesChange={handleValuesChange}
          handleCheckIsApplyWithPromo={handleCheckIsApplyWithPromo}
          promotionCampaignTiers={promotionCampaignTiers}
          handleActionCampaign={handleUpdateClick}
          visibleConfirmModal={visibleConfirmModal}
          handleOpenConfirmModal={handleOpenConfirmModal}
          handleCancelConfirmModal={handleCancelConfirmModal}
          dataConfirmModal={dataConfirmModal}
          loadingUpdate={loadingAll}
          initialValues={initValues}
          indexErrorCombo={indexErrorCombo}
          handleProductDataSourceChange={handleProductDataSourceChange}
          promotionCampaignID={data?.id}
        />
      )}
    </Spin>
  );
};

export default CloneCampaign;
